module.exports = __webpack_public_path__ + "static/media/tag-outline.72fecb3c.svg";